/* =============================================================================
   ADSCALAR PDP — vanilla-JS re-implementation of the Hydrogen React interactions.
   Variant select (no-blink + URL sync), accordion, sticky ATC bar,
   gallery lightbox, size gate, wishlist toggle, add-to-cart via /cart/add.
   ========================================================================== */
(function () {
  var root = document.querySelector('.asc-pdp');
  if (!root) return;

  var variants = [];
  try { variants = JSON.parse(root.querySelector('[data-variants]').textContent || '[]'); } catch (e) {}

  var selected = { Size: '' };
  var sizeOptionName = root.getAttribute('data-size-option') || 'Size';

  // Pre-select non-size options to their first value (mirrors Hydrogen default).
  (root.getAttribute('data-options') || '').split('||').forEach(function (pair) {
    var bits = pair.split('::');
    if (bits[0] && bits[0].toLowerCase() !== 'size') selected[bits[0]] = bits[1] || '';
  });

  // ── Resolve the variant matching the current selection ──────────────────
  function resolveVariant() {
    return variants.find(function (v) {
      return v.options.every(function (o) { return selected[o.name] === o.value; });
    }) || null;
  }

  function fmt(amount) {
    // amount is in major units (rupees); render ₹ with grouping, no decimals.
    var n = Math.round(parseFloat(amount));
    return '₹' + n.toLocaleString('en-IN');
  }

  // ── Update price / ATC label / sticky bar on selection change ───────────
  var priceEl = root.querySelector('[data-price]');
  var basePriceEl = root.querySelector('[data-base-price]');
  var comparePriceEl = root.querySelector('[data-compare-price]');
  var mrpWrap = root.querySelector('[data-mrp-wrap]') || (comparePriceEl && comparePriceEl.closest('.ek-pdp-mrp'));
  var promoFactor = 0.8;
  var atcBtn = root.querySelector('[data-atc]');
  var atcLabel = root.querySelector('[data-atc-label]');
  var stickyAdd = document.querySelector('[data-sticky-add]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var footAdd = document.querySelector('[data-sticky-foot-add]');
  var footSize = document.querySelector('[data-sticky-foot-size]');
  var footPrice = document.querySelector('[data-sticky-foot-price]');
  var addingToCart = false;
  var priceMirror = root.querySelector('[data-price-mirror]');
  if (priceMirror && priceEl) priceMirror.textContent = priceEl.textContent;

  function refresh() {
    var v = resolveVariant();
    var needsSize = !!sizeHasOption && !selected[sizeOptionName];
    var soldOut = !needsSize && v && !v.available;

    if (v) {
      if (basePriceEl) basePriceEl.textContent = fmt(v.price);
      if (priceEl) priceEl.textContent = fmt(v.price * promoFactor);
      if (stickyPrice) stickyPrice.textContent = fmt(v.price * promoFactor);
      if (footPrice) footPrice.textContent = fmt(v.price * promoFactor);
      var prepaidEstimate = root.querySelector('[data-prepaid-estimate]');
      var stickyMrp = root.querySelector('[data-sticky-mrp]');
      root.querySelectorAll('[data-prepaid-estimate]').forEach(function (el) { el.textContent = fmt(v.price * promoFactor * 0.9); });
      if (stickyMrp) stickyMrp.textContent = fmt(v.price);
      var closingPrice = root.querySelector('[data-price-mirror]');
      if (closingPrice) closingPrice.textContent = fmt(v.price * promoFactor);
      if (comparePriceEl) {
        if (v.compareAt && v.compareAt > v.price) {
          comparePriceEl.textContent = fmt(v.compareAt);
          if (mrpWrap) mrpWrap.hidden = false;
        } else {
          comparePriceEl.textContent = '';
          if (mrpWrap) mrpWrap.hidden = true;
        }
      }
    }

    syncSizeSheet();
    if (atcLabel) {
      // Mobile in-page ATC has no "· Size" suffix (matches MobilePDP); only DesktopPDP appends it.
      var isDesktop = window.matchMedia('(min-width:1024px)').matches;
      if (needsSize) atcLabel.textContent = 'Select Size';
      else if (soldOut) atcLabel.textContent = 'Sold Out';
      else if (isDesktop && selected[sizeOptionName]) atcLabel.textContent = 'Add to Bag · ' + selected[sizeOptionName];
      else atcLabel.textContent = 'Add to Bag';
    }
    if (atcBtn) atcBtn.classList.toggle('is-soldout', !!soldOut);

    // Mobile sticky footer Add button — label + gating mirror the main ATC.
    if (footAdd) {
      if (needsSize) footAdd.textContent = 'Select Size';
      else if (soldOut) footAdd.textContent = 'Sold Out';
      else footAdd.textContent = 'Add to Bag';
      // Keep Select Size tappable so it can scroll the shopper to the selector.
      footAdd.disabled = !!soldOut;
    }
  }

  // ── Size grid selection (no-blink, replaceState URL sync) ───────────────
  var sizeGrid = root.querySelector('[data-size-grid]');
  var sizeHasOption = !!sizeGrid;
  // syncUrl=false for the automatic pre-selection on load: the shopper hasn't
  // chosen anything yet, so the address bar must not gain a ?size= they didn't ask for.
  function pickCell(cell, syncUrl) {
    var sz = cell.getAttribute('data-size');
    selected[sizeOptionName] = sz;
    sizeGrid.querySelectorAll('.asc-size-cell').forEach(function (c) {
      c.classList.toggle('sel', c === cell);
      c.setAttribute('aria-pressed', c === cell ? 'true' : 'false');
    });
    var sizeError = root.querySelector('[data-size-error]');
    if (sizeError) sizeError.hidden = true;
    if (syncUrl) {
      // Silent URL sync — share/deep-link without a reload.
      try {
        var params = new URLSearchParams(window.location.search);
        params.set(sizeOptionName.toLowerCase(), sz);
        window.history.replaceState(null, '', window.location.pathname + '?' + params.toString());
      } catch (e2) {}
    }
    // Mirror into the sticky-bar selects if present.
    var ss = document.querySelector('[data-sticky-size]');
    if (ss) ss.value = sz;
    if (footSize) footSize.value = sz;
    refresh();
    // Let isolated modules follow the pick (Shop the Pair mirrors the size).
    try { root.dispatchEvent(new CustomEvent('ek:size-change', { bubbles: true, detail: { size: sz } })); } catch (e3) {}
  }

  if (sizeGrid) {
    sizeGrid.addEventListener('click', function (e) {
      var cell = e.target.closest('.asc-size-cell');
      if (!cell || cell.classList.contains('oos')) return;
      pickCell(cell, true);
    });
  }


  var sizeSheet = null, sheetGrid = null, sheetAdd = null, sheetReturn = null, sheetOverflow = '';
  if (sizeGrid && footPrice) {
    sizeSheet = document.createElement('dialog');
    sizeSheet.className = 'ek-size-sheet';
    sizeSheet.setAttribute('aria-labelledby', 'ek-size-sheet-heading');
    sizeSheet.innerHTML = '<div class="ek-size-sheet-body"><button type="button" class="ek-size-sheet-close" aria-label="Close size selection">×</button><h2 id="ek-size-sheet-heading">Select Size</h2><p class="ek-size-sheet-product"></p><div class="ek-size-sheet-options"></div><p class="ek-size-sheet-error" role="alert" hidden>Please select a size.</p></div><div class="ek-size-sheet-buy"><div class="ek-size-sheet-offer"></div><div class="ek-size-sheet-row"><div class="ek-size-sheet-price"></div><button type="button" class="asc-sf-add" data-sheet-add disabled>Add to Bag</button></div></div>';
    sizeSheet.querySelector('.ek-size-sheet-product').textContent = (root.querySelector('h1') || {}).textContent || '';
    sheetGrid = sizeGrid.cloneNode(true);
    sheetGrid.removeAttribute('data-size-grid');
    sheetGrid.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
    sheetGrid.querySelectorAll('.oos').forEach(function (cell) {
      var label = document.createElement('span');
      label.className = 'ek-size-sheet-soldout';
      label.textContent = 'Sold out';
      cell.appendChild(label);
    });
    sizeSheet.querySelector('.ek-size-sheet-options').appendChild(sheetGrid);
    var guide = root.querySelector('[data-asc-open-sizeguide]');
    if (guide) {
      var sheetGuide = document.createElement('button');
      sheetGuide.type = 'button';
      sheetGuide.className = 'ek-size-sheet-guide';
      sheetGuide.textContent = guide.textContent;
      sheetGuide.addEventListener('click', function () { closeSizeSheet(); guide.click(); });
      sizeSheet.querySelector('.ek-size-sheet-options').before(sheetGuide);
    }
    var offer = root.querySelector('.ek-prepaid-panel');
    if (offer) sizeSheet.querySelector('.ek-size-sheet-offer').appendChild(offer.cloneNode(true));
    sizeSheet.querySelector('.ek-size-sheet-price').appendChild(footPrice.closest('.asc-sf-price').cloneNode(true));
    sheetAdd = sizeSheet.querySelector('[data-sheet-add]');
    document.body.appendChild(sizeSheet);
    sheetGrid.addEventListener('click', function (e) {
      var cell = e.target.closest('.asc-size-cell');
      if (!cell || cell.disabled || cell.classList.contains('oos')) return;
      var original = sizeGrid.querySelector('[data-size="' + CSS.escape(cell.getAttribute('data-size')) + '"]');
      if (original) pickCell(original, true);
    });
    sheetAdd.addEventListener('click', function () {
      if (!resolveVariant() || !selected[sizeOptionName] || addingToCart) return;
      closeSizeSheet();
      addToCart(atcBtn || footAdd);
    });
    sizeSheet.querySelector('.ek-size-sheet-close').addEventListener('click', closeSizeSheet);
    sizeSheet.addEventListener('click', function (e) {
      if (e.target !== sizeSheet) return;
      var rect = sizeSheet.getBoundingClientRect();
      if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) closeSizeSheet();
    });
    sizeSheet.addEventListener('cancel', function (e) { e.preventDefault(); closeSizeSheet(); });
    window.addEventListener('ek:cart-open', closeSizeSheet);
  }
  function syncSizeSheet() {
    if (!sizeSheet) return;
    var v = resolveVariant();
    sheetGrid.querySelectorAll('.asc-size-cell').forEach(function (cell) {
      var on = cell.getAttribute('data-size') === selected[sizeOptionName];
      cell.classList.toggle('sel', on);
      cell.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    sheetAdd.disabled = !v || !v.available || addingToCart;
    if (v) {
      sizeSheet.querySelector('[data-sticky-foot-price]').textContent = fmt(v.price * promoFactor);
      sizeSheet.querySelector('[data-sticky-mrp]').textContent = fmt(v.price);
      var estimate = sizeSheet.querySelector('[data-prepaid-estimate]');
      if (estimate) estimate.textContent = fmt(v.price * promoFactor * 0.9);
    }
    sizeSheet.querySelector('.ek-size-sheet-error').hidden = !!selected[sizeOptionName];
  }
  function openSizeSheet() {
    if (!sizeSheet || sizeSheet.open) return;
    sheetReturn = document.activeElement;
    sheetOverflow = document.body.style.overflow;
    syncSizeSheet();
    sizeSheet.showModal();
    document.body.style.overflow = 'hidden';
    document.body.classList.add('ek-size-sheet-open');
    syncStickyVisibility();
  }
  function closeSizeSheet() {
    if (!sizeSheet || !sizeSheet.open) return;
    sizeSheet.close();
    document.body.style.overflow = sheetOverflow;
    document.body.classList.remove('ek-size-sheet-open');
    syncStickyVisibility();
    if (sheetReturn && sheetReturn.isConnected) sheetReturn.focus({ preventScroll: true });
  }

  // Apply a size carried in the URL on load (deep-link parity).
  try {
    var urlSize = new URLSearchParams(window.location.search).get(sizeOptionName.toLowerCase());
    if (urlSize && sizeGrid) {
      var match = sizeGrid.querySelector('.asc-size-cell[data-size="' + CSS.escape(urlSize) + '"]:not(.oos)');
      if (match) match.click();
    }
  } catch (e) {}

  // Sticky-bar size <select> mirrors into the grid.
  var stickySize = document.querySelector('[data-sticky-size]');
  if (stickySize) {
    stickySize.addEventListener('change', function () {
      var cell = sizeGrid && sizeGrid.querySelector('.asc-size-cell[data-size="' + CSS.escape(this.value) + '"]:not(.oos)');
      if (cell) cell.click();
    });
  }

  // Mobile footer size <select> mirrors into the grid.
  if (footSize) {
    footSize.addEventListener('change', function () {
      var cell = sizeGrid && sizeGrid.querySelector('.asc-size-cell[data-size="' + CSS.escape(this.value) + '"]:not(.oos)');
      if (cell) cell.click();
    });
  }

  // ── Size gate (pulse the grid when ATC pressed without a size) ──────────
  function promptSize() {
    if (!sizeGrid) return;
    if (window.matchMedia('(max-width:1023px)').matches && sizeSheet) { openSizeSheet(); return; }
    var msg = root.querySelector('[data-size-error]');
    if (msg) msg.hidden = false;
    sizeGrid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    sizeGrid.classList.add('pulse');
    setTimeout(function () { sizeGrid.classList.remove('pulse'); }, 1200);
  }

  // ── Add to cart (Shopify AJAX /cart/add.js) ─────────────────────────────
  function addToCart(btn) {
    if (addingToCart) return;
    var v = resolveVariant();
    if (sizeHasOption && !selected[sizeOptionName]) { promptSize(); return; }
    if (!v || !v.available) return;

    addingToCart = true;
    var label = btn.querySelector('[data-atc-label]');
    var prev = label ? label.textContent : '';
    btn.disabled = true;
    if (label) label.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: v.id, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('Unable to add selected variant'); return r.json(); })
      .then(function () {
        btn.classList.add('added');
        if (label) label.textContent = 'Added to Bag';
        // Report the variant actually added, so add_to_cart value is exact.
        try {
          window.dispatchEvent(new CustomEvent('ek:add-to-cart', {
            detail: {
              variant_id: v.id,
              sku: v.sku,
              variant_title: v.title,
              price: v.price * promoFactor,
              quantity: 1
            }
          }));
        } catch (e) {}
        // Open the AdScalar cart drawer (re-renders with the new line + count).
        try { window.dispatchEvent(new Event('ek:cart-open')); } catch (e) {}
        setTimeout(function () {
          addingToCart = false;
          btn.classList.remove('added'); btn.disabled = false;
          refresh();
          if (label) label.textContent = prev;
        }, 1400);
      })
      .catch(function () {
        addingToCart = false;
        btn.disabled = false;
        if (label) label.textContent = prev;
      });
  }

  if (atcBtn) atcBtn.addEventListener('click', function () { addToCart(atcBtn); });
  if (stickyAdd) stickyAdd.addEventListener('click', function () {
    if (sizeHasOption && !selected[sizeOptionName]) { promptSize(); return; }
    addToCart(atcBtn || stickyAdd);
  });
  if (footAdd) footAdd.addEventListener('click', function () {
    if (sizeHasOption && !selected[sizeOptionName]) { promptSize(); return; }
    addToCart(atcBtn || footAdd);
  });

  function syncStickyVisibility() {
    var footer = document.querySelector('[data-sticky-footer]');
    if (!footer) return;
    var blocked = !!document.querySelector('.ek-size-sheet[open], .asc-cd.open, .asc-size-overlay.open, .asc-size-drawer.open, .asc-lightbox.open, [data-asc-pop-root].open');
    var checkout = document.querySelector('.razorpay-container');
    if (checkout && checkout.getClientRects().length && getComputedStyle(checkout).visibility !== 'hidden') blocked = true;
    footer.classList.toggle('is-obscured', blocked);
  }
  window.addEventListener('ek:cart-open', function () { setTimeout(syncStickyVisibility, 30); });
  document.addEventListener('click', function () { setTimeout(syncStickyVisibility, 30); }, true);
  var stickyObserver = new MutationObserver(syncStickyVisibility);
  stickyObserver.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class', 'aria-hidden'] });

  // ── Buy Now (express single-item checkout) ──────────────────────────────
  var buyBtn = root.querySelector('[data-buynow]');
  if (buyBtn) buyBtn.addEventListener('click', function () {
    var v = resolveVariant();
    if (sizeHasOption && !selected[sizeOptionName]) { promptSize(); return; }
    if (!v || !v.available) return;
    buyBtn.disabled = true;

    // Buy Now must not silently increment an item that is already in the cart.
    // Check the current cart first; only add one when this exact variant is absent.
    // Existing deliberate quantities are preserved.
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var existing = (cart.items || []).some(function (item) {
          return Number(item.variant_id) === Number(v.id);
        });
        if (existing) return { added: false };
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: v.id, quantity: 1 })
        }).then(function (r) {
          if (!r.ok) throw new Error('Unable to add selected variant');
          return { added: true };
        });
      })
      .then(function (result) {
        if (result && result.added) {
          // Report AddToCart only when Buy Now really added a new line.
          try {
            window.dispatchEvent(new CustomEvent('ek:add-to-cart', {
              detail: {
                variant_id: v.id,
                sku: v.sku,
                variant_title: v.title,
                price: v.price * promoFactor,
                quantity: 1
              }
            }));
          } catch (e) {}
        }
        // Open + re-render the drawer so the real checkout button is present
        // before we click it. Magic Checkout binds to this button.
        return window.ekCart && window.ekCart.refresh
          ? window.ekCart.refresh(true)
          : null;
      })
      .then(function () {
        var btn = document.querySelector('.asc-cd-checkout-form button[name="checkout"]');
        if (btn) { btn.click(); return; }
        // Drawer footer unavailable — submit a genuine cart POST rather than a
        // bare /checkout hop, so Shopify still applies cart-level discounts.
        var f = document.createElement('form');
        f.action = '/cart';
        f.method = 'post';
        var b = document.createElement('button');
        b.type = 'submit';
        b.name = 'checkout';
        f.appendChild(b);
        document.body.appendChild(f);
        f.submit();
      })
      .catch(function () {
        buyBtn.disabled = false;
        if (window.ekCart && window.ekCart.open) window.ekCart.open();
      });
  });

  // ── Closing-CTA add button ──────────────────────────────────────────────
  var closeAdd = root.querySelector('[data-closing-add]');
  if (closeAdd) closeAdd.addEventListener('click', function () {
    if (sizeHasOption && !selected[sizeOptionName]) { promptSize(); return; }
    addToCart(atcBtn || closeAdd);
  });

  // ── Wishlist (localStorage; mirrors Hydrogen's persisted store) ─────────
  // Entries are {id, title, url, img, price} objects (see asc-pages.js's
  // matching card-side toggle, fixed alongside this one 2026-09-06) so
  // /pages/wishlist can render real cards. This button used to store/match
  // bare id strings via indexOf() — once the card toggle started saving
  // objects, indexOf(pid) would never match one, so hearting the same
  // product on a card and then a PDP (or vice versa) created a duplicate
  // entry instead of un-hearting it. idOf() matches either shape.
  var wishBtn = root.querySelector('[data-wish]');
  if (wishBtn) {
    var pid = wishBtn.getAttribute('data-pid');
    var KEY = 'ek_wishlist';
    function idOf(entry) { return typeof entry === 'string' ? entry : entry && entry.id; }
    function getWish() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    function setOn(on) { wishBtn.classList.toggle('on', on); wishBtn.setAttribute('aria-pressed', on ? 'true' : 'false'); }
    setOn(getWish().map(idOf).indexOf(pid) > -1);
    wishBtn.addEventListener('click', function () {
      var list = getWish(); var i = list.map(idOf).indexOf(pid); var adding = i === -1;
      if (adding) {
        list.push({
          id: pid,
          title: wishBtn.getAttribute('data-title') || '',
          url: wishBtn.getAttribute('data-url') || '',
          img: wishBtn.getAttribute('data-img') || '',
          price: wishBtn.getAttribute('data-price') || ''
        });
      } else {
        list.splice(i, 1);
      }
      localStorage.setItem(KEY, JSON.stringify(list));
      try { window.dispatchEvent(new Event('ek:wishlist-change')); } catch (e) {}
      setOn(adding);
      if (adding) {
        var svg = wishBtn.querySelector('svg');
        if (svg) { svg.classList.add('asc-heart-pulse'); setTimeout(function () { svg.classList.remove('asc-heart-pulse'); }, 600); }
      }
    });
  }

  // ── Accordions (single-open) ────────────────────────────────────────────
  root.querySelectorAll('.asc-acc-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var body = document.getElementById(btn.getAttribute('aria-controls'));
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      root.querySelectorAll('.asc-acc-btn').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        var bd = document.getElementById(b.getAttribute('aria-controls'));
        if (bd) bd.hidden = true;
      });
      if (!isOpen) { btn.setAttribute('aria-expanded', 'true'); if (body) body.hidden = false; }
    });
  });

  // ── Sticky ATC bar (IntersectionObserver on the main ATC) ───────────────
  var stickyBar = document.querySelector('.asc-sticky-atc');
  if (stickyBar && atcBtn && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { stickyBar.classList.toggle('show', !en.isIntersecting); });
    }, { rootMargin: '-56px 0px 0px 0px', threshold: 0 });
    io.observe(atcBtn);
  }

  // ── Mobile sticky footer (reveal when in-page ATC scrolls out, hide over
  //    the closing CTA) — mirrors MobilePDP's two-observer reveal logic. ────
  var stickyFoot = document.querySelector('[data-sticky-footer]');
  var mainAtcMobile = document.querySelector('[data-main-atc-mobile]');
  if (stickyFoot && mainAtcMobile && 'IntersectionObserver' in window) {
    var atcOut = false, closingIn = false;
    function syncFoot() {
      var show = atcOut && !closingIn;
      stickyFoot.classList.toggle('show', show);
      stickyFoot.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    new IntersectionObserver(function (entries) {
      atcOut = entries[0] ? !entries[0].isIntersecting : false; syncFoot();
    }, { threshold: 0 }).observe(mainAtcMobile);
    var closingCta = document.querySelector('[data-closing-cta]');
    if (closingCta) {
      new IntersectionObserver(function (entries) {
        closingIn = entries[0] ? entries[0].isIntersecting : false; syncFoot();
      }, { threshold: 0 }).observe(closingCta);
    }
  }

  // ── Mobile gallery carousel (scroll-snap → dots + counter) ──────────────
  var gmTrack = root.querySelector('[data-gm-track]');
  if (gmTrack) {
    var firstGalleryImage = gmTrack.querySelector('[data-gm-slide] img');
    function sizeGalleryToImage() {
      if (!firstGalleryImage) return;
      var w = firstGalleryImage.naturalWidth || Number(firstGalleryImage.getAttribute('width'));
      var h = firstGalleryImage.naturalHeight || Number(firstGalleryImage.getAttribute('height'));
      if (w && h) gmTrack.style.setProperty('--ek-gallery-ratio', w + '/' + h);
    }
    if (firstGalleryImage) firstGalleryImage.addEventListener('load', sizeGalleryToImage);
    sizeGalleryToImage();
    var gmCounter = root.querySelector('[data-gm-counter]');
    var gmDots = root.querySelectorAll('[data-gm-dots] .asc-gm-dot');
    var gmSlides = gmTrack.querySelectorAll('[data-gm-slide]');
    var gmTotal = gmSlides.length;
    var gmRaf = 0;
    function gmSync() {
      var w = gmSlides.length > 1 ? gmSlides[1].offsetLeft - gmSlides[0].offsetLeft : gmTrack.clientWidth;
      if (!w) return;
      var i = Math.round(gmTrack.scrollLeft / w);
      if (i < 0) i = 0; if (i > gmTotal - 1) i = gmTotal - 1;
      if (gmCounter) gmCounter.textContent = (i + 1) + ' / ' + gmTotal;
      for (var d = 0; d < gmDots.length; d++) {
        gmDots[d].classList.toggle('on', d === i);
      }
    }
    gmTrack.addEventListener('scroll', function () {
      if (gmRaf) return;
      gmRaf = requestAnimationFrame(function () { gmRaf = 0; gmSync(); });
    }, { passive: true });
  }

  // ── Gallery lightbox ────────────────────────────────────────────────────
  var lb = document.querySelector('.asc-lightbox');
  if (lb) {
    var imgs = JSON.parse(root.querySelector('[data-gallery]').textContent || '[]');
    var lbImg = lb.querySelector('img');
    var lbCount = lb.querySelector('.lb-count');
    var idx = 0;
    function show(i) {
      idx = (i + imgs.length) % imgs.length;
      lbImg.src = imgs[idx];
      if (lbCount) lbCount.textContent = (idx + 1) + ' / ' + imgs.length;
    }
    function open(i) { show(i); lb.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function close() { lb.classList.remove('open'); document.body.style.overflow = ''; }
    root.querySelectorAll('[data-lb-open]').forEach(function (el) {
      el.addEventListener('click', function () { open(parseInt(el.getAttribute('data-lb-open'), 10) || 0); });
    });
    lb.querySelector('.lb-close').addEventListener('click', close);
    lb.querySelector('.lb-prev').addEventListener('click', function () { show(idx - 1); });
    lb.querySelector('.lb-next').addEventListener('click', function () { show(idx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
  }

  // ── Delivery estimator (pincode → ~4-7 day window) ──────────────────────
  var del = root.querySelector('[data-delivery]');
  if (del) {
    var input = del.querySelector('input');
    var btn = del.querySelector('.check');
    var out = del.querySelector('.result');
    btn.addEventListener('click', function () {
      var pin = (input.value || '').trim();
      if (!/^\d{6}$/.test(pin)) { out.innerHTML = 'Enter a valid 6-digit pincode.'; return; }
      var d = new Date(); d.setDate(d.getDate() + 5);
      var opts = { weekday: 'short', day: 'numeric', month: 'short' };
      out.innerHTML = 'Delivering by <strong>' + d.toLocaleDateString('en-IN', opts) + '</strong> to ' + pin;
    });
  }

  // ── Public API for the size drawers (asc-size.js) ──
  window.ekPDP = {
    selectSize: function (sz) {
      if (!sizeGrid) return;
      var c = sizeGrid.querySelector('.asc-size-cell[data-size="' + CSS.escape(sz) + '"]:not(.oos)');
      if (c) c.click();
    },
    selectedSize: function () { return selected[sizeOptionName] || ''; },
    selectableSizes: function () {
      var out = [];
      variants.forEach(function (v) {
        if (!v.available) return;
        v.options.forEach(function (o) {
          if (o.name === sizeOptionName && out.indexOf(o.value) === -1) out.push(o.value);
        });
      });
      return out;
    }
  };

  // Re-run refresh when crossing the 1024px breakpoint so the ATC label's
  // "· Size" desktop suffix is added/dropped correctly on resize.
  if (window.matchMedia) {
    var mqDesktop = window.matchMedia('(min-width:1024px)');
    var onMq = function () { if (mqDesktop.matches) closeSizeSheet(); refresh(); };
    if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', onMq);
    else if (mqDesktop.addListener) mqDesktop.addListener(onMq);
  }

  refresh();
})();

/* ── Shop the Pair — bundle cross-sell (custom.shop_the_pair metafield) ──────
   Self-contained on purpose (mirrors this file's own pattern of independent
   IIFEs below): re-resolves the main product's selected variant from the same
   .asc-pdp root rather than reaching into the module above, so this feature
   can be deleted or disabled without touching the main add-to-cart logic. */
(function () {
  var section = document.querySelector('[data-shop-pair]');
  if (!section) return;

  var root = document.querySelector('.asc-pdp');
  var mainVariants = [];
  try { mainVariants = JSON.parse(root.querySelector('[data-variants]').textContent || '[]'); } catch (e) {}
  var mainSelected = {};
  var mainSizeOptionName = root.getAttribute('data-size-option') || 'Size';
  (root.getAttribute('data-options') || '').split('||').forEach(function (pair) {
    var bits = pair.split('::');
    if (bits[0] && bits[0].toLowerCase() !== 'size') mainSelected[bits[0]] = bits[1] || '';
  });
  var mainSizeGrid = root.querySelector('[data-size-grid]');

  function resolveMainVariant() {
    // Read the live pick off the size grid's own "sel" class (set by the main
    // add-to-cart module above) rather than a shared variable, since this IIFE
    // is deliberately isolated from that module's closure.
    if (mainSizeGrid) {
      var picked = mainSizeGrid.querySelector('.asc-size-cell.sel');
      if (picked) mainSelected[mainSizeOptionName] = picked.getAttribute('data-size');
    }
    return mainVariants.find(function (v) {
      return v.options.every(function (o) { return mainSelected[o.name] === o.value; });
    }) || null;
  }

  var pairVariants = [];
  try { pairVariants = JSON.parse(section.querySelector('[data-pair-variants]').textContent || '[]'); } catch (e) {}
  var sizePicker = section.querySelector('[data-pair-size-picker]');
  var pairSizeOptionName = sizePicker ? sizePicker.getAttribute('data-size-option') : null;
  var pairSelectedSize = '';

  function resolvePairVariant() {
    if (!pairSizeOptionName) {
      var defId = +section.querySelector('[data-pair-add]').getAttribute('data-pair-default-variant');
      return pairVariants.find(function (v) { return v.id === defId; }) || pairVariants[0] || null;
    }
    return pairVariants.find(function (v) {
      return v.options.some(function (o) { return o.name === pairSizeOptionName && o.value === pairSelectedSize; });
    }) || null;
  }

  function selectPairSize(btn) {
    pairSelectedSize = btn.getAttribute('data-pair-size');
    sizePicker.querySelectorAll('[data-pair-size]').forEach(function (b) {
      b.classList.toggle('on', b === btn);
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
  }

  // Two products can spell the same size differently — this store has a main
  // product using "XXL" paired with one using "2XL" (reported 2026-09-07: the
  // main variant read XXL while the pair sat on a stale S). Compare on a
  // canonical form so those match: 2XL -> XXL, 3XL -> XXXL, case and
  // separators ignored.
  function canonSize(v) {
    var t = String(v == null ? '' : v).toUpperCase().replace(/[\s._-]/g, '');
    var m = t.match(/^(\d)XL$/);
    if (m && +m[1] > 1 && +m[1] < 7) t = new Array(+m[1] + 1).join('X') + 'L';
    return t;
  }

  function clearPairSize() {
    pairSelectedSize = '';
    sizePicker.querySelectorAll('[data-pair-size]').forEach(function (b) {
      b.classList.remove('on');
      b.setAttribute('aria-pressed', 'false');
    });
  }

  // Follow the main size grid (requested 2026-09-06): picking S on the main
  // product picks S on the pair too, when the pair has it in stock. The
  // shopper can still override on the pair picker afterwards. If the pair
  // genuinely has no counterpart, the old selection is cleared rather than
  // left contradicting the main pick.
  function syncPairSize(sz) {
    if (!sizePicker || !sz) return;
    var want = canonSize(sz);
    var btn = null;
    var all = sizePicker.querySelectorAll('[data-pair-size]');
    for (var i = 0; i < all.length; i++) {
      if (all[i].disabled) continue;
      if (canonSize(all[i].getAttribute('data-pair-size')) === want) { btn = all[i]; break; }
    }
    if (btn) selectPairSize(btn);
    else clearPairSize();
  }

  if (sizePicker) {
    sizePicker.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pair-size]');
      if (!btn || btn.disabled) return;
      selectPairSize(btn);
    });
    document.addEventListener('ek:size-change', function (e) {
      syncPairSize(e.detail && e.detail.size);
    });
    // Initial: the main module already pre-selected a size before this ran.
    var initSel = mainSizeGrid && mainSizeGrid.querySelector('.asc-size-cell.sel');
    if (initSel) syncPairSize(initSel.getAttribute('data-size'));
  }

  var addBtn = section.querySelector('[data-pair-add]');
  addBtn.addEventListener('click', function () {
    // Bundling assumes the shopper has already picked their own size above —
    // nudge back up to that grid rather than silently adding the wrong size.
    if (mainSizeGrid && !mainSizeGrid.querySelector('.asc-size-cell.sel')) {
      mainSizeGrid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      mainSizeGrid.classList.add('pulse');
      setTimeout(function () { mainSizeGrid.classList.remove('pulse'); }, 1200);
      return;
    }
    if (sizePicker && !pairSelectedSize) {
      sizePicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      sizePicker.classList.add('pulse');
      setTimeout(function () { sizePicker.classList.remove('pulse'); }, 1200);
      return;
    }

    var mainVariant = resolveMainVariant();
    var pairVariant = resolvePairVariant();
    if (!mainVariant || !mainVariant.available || !pairVariant || !pairVariant.available) return;

    var label = addBtn.querySelector('[data-pair-add-label]');
    var prevLabel = label ? label.textContent : '';
    addBtn.disabled = true;
    if (label) label.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [
        { id: mainVariant.id, quantity: 1 },
        { id: pairVariant.id, quantity: 1 }
      ] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        try {
          window.dispatchEvent(new CustomEvent('ek:add-to-cart', { detail: {
            variant_id: mainVariant.id, sku: mainVariant.sku, variant_title: mainVariant.title,
            price: mainVariant.price, quantity: 1
          } }));
          window.dispatchEvent(new CustomEvent('ek:add-to-cart', { detail: {
            variant_id: pairVariant.id, sku: pairVariant.sku, variant_title: pairVariant.title,
            price: pairVariant.price, quantity: 1
          } }));
          window.dispatchEvent(new Event('ek:cart-open'));
        } catch (e) {}
        if (label) label.textContent = 'Added to Bag';
        setTimeout(function () { addBtn.disabled = false; if (label) label.textContent = prevLabel; }, 1400);
      })
      .catch(function () {
        addBtn.disabled = false;
        if (label) label.textContent = prevLabel;
      });
  });
})();

/* ── Product recommendations ("You may also like") — fetch + inject via Recommendations API ── */
(function () {
  var el = document.querySelector('[data-asc-recs]');
  if (!el || !el.getAttribute('data-url')) return;
  fetch(el.getAttribute('data-url')).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
    if (!html) return; var tmp = document.createElement('div'); tmp.innerHTML = html;
    if (tmp.querySelector('.asc-recs')) el.innerHTML = html;
  }).catch(function () {});
})();

/* ── Recently viewed (port of RecentlyViewedSection) — localStorage tracker + client render ── */
(function () {
  var el = document.querySelector('[data-asc-recent]');
  if (!el) return;
  var cur = null; try { cur = JSON.parse(el.querySelector('[data-recent-product]').textContent); } catch (e) {}
  var KEY = 'asc_recent', list = [];
  try { list = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) {}
  if (cur && cur.id) {
    list = list.filter(function (p) { return p && p.id !== cur.id; });
    list.unshift(cur); list = list.slice(0, 12);
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  var others = list.filter(function (p) { return p && (!cur || p.id !== cur.id); }).slice(0, 8);
  if (others.length === 0) return;
  function esc(s) { return ('' + (s || '')).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function recentBase(p) {
    if (Number(p.basePrice) > 0) return Number(p.basePrice);
    return Number(String(p.price || '').replace(/<[^>]*>/g, '').replace(/[^0-9.]/g, '')) || 0;
  }
  function recentMoney(n) { return '₹' + Math.round(n).toLocaleString('en-IN'); }
  el.querySelector('[data-recent-rail]').innerHTML = others.map(function (p) {
    return '<article class="asc-card"><div class="asc-card-media"><a href="' + esc(p.url) + '" aria-label="' + esc(p.title) + '">' +
      (p.img ? '<img class="asc-card-img1" src="' + esc(p.img) + '" width="480" height="600" loading="lazy" alt="">' : '') +
      '</a></div><a class="asc-card-info" href="' + esc(p.url) + '"><span class="asc-card-title">' + esc(p.title) +
      '</span><span class="asc-card-prices"><s class="tabular" style="color:var(--asc-ink-soft);font-size:12px">' + esc(recentMoney(recentBase(p))) + '</s><span class="asc-card-price tabular">' + esc(recentMoney(recentBase(p) * 0.8)) + '</span><span class="ek-pdp-off">20% OFF</span></span><span class="ek-pdp-promo-note">Extra 10% OFF on prepaid orders</span></a></article>';
  }).join('');
  el.hidden = false;
})();

/* Same-day dispatch live countdown — port of Hydrogen DispatchCountdown (4 PM IST cutoff).
   IST = UTC+5:30 (no DST), so 16:00 IST == 10:30 UTC every day. Label switches
   at the cutoff itself — "Same-day dispatch" before 4 PM, "Ships tomorrow"
   after — matching the live Hydrogen reference exactly (confirmed 2026-09-05:
   it read "Ships tomorrow · order in 19h 57m..." past cutoff, this previously
   always said "Same-day dispatch" regardless of time of day). */
(function () {
  var el = document.querySelector('[data-dispatch-text]');
  var timeEl = document.querySelector('[data-dispatch-time]');
  if (!el) return;
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    var now = new Date();
    var cutoff = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 10, 30, 0));
    var pastCutoffToday = now.getTime() >= cutoff.getTime();
    if (pastCutoffToday) { cutoff.setUTCDate(cutoff.getUTCDate() + 1); }
    var diff = Math.max(0, Math.floor((cutoff.getTime() - now.getTime()) / 1000));
    var h = Math.floor(diff / 3600), m = Math.floor((diff % 3600) / 60), s = diff % 60;
    var label = pastCutoffToday ? 'Ships tomorrow' : 'Same-day dispatch';
    // Hydrogen: "Ships tomorrow · order in " + bold tabular "17h 20m 26s" (middle dot, not em dash).
    el.textContent = label + ' · order in';
    if (timeEl) {
      timeEl.textContent = h + 'h ' + pad(m) + 'm ' + pad(s) + 's';
      timeEl.hidden = false;
    }
  }
  tick();
  setInterval(tick, 1000);
})();
